
<p-tabView [(activeIndex)]="activeIndex"  (click)="changeIndex(activeIndex)">
  <p-tabPanel header="{{'TabVerifyPallets.verifyPalletsHeader' | translate}}" >
    <div class="card" *ngIf="dto && detail">

      <div class="header-card">
        <div class="container-title">
          <h2 class="title-main">{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PageTitle1' | translate}}</h2>
        </div>
        <div>
          <p-button class="load-info-btn" label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadInformationButton' | translate }}" icon="pi pi-upload" (click)="showDialog()" *ngIf="detail && (isCreate || isEdit) && !success"/>
          <p-button class="ml-2" label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadLatamButton' | translate }}" icon="pi pi-upload" (click)="showDialogLatam()" *ngIf="detail && (isCreate || isEdit) && !success"/>
          <p-button class="ml-2" label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.DownloadLatamButton' | translate }}" [style]="{'background-color':'#8c2b87'}" icon="pi pi-download" (click)="downloadLatamPallets()" *ngIf="detail?.hasLatamData && (isCreate || isEdit) && !success"/>
          <p-button class="ml-2" label="{{'AssignStock.LoadFromStock' | translate }}" (click)="goToAssignPalletStock()"  *ngIf="detail && (isCreate || isEdit) && !success"/>
        </div>
      </div>
      <div class="body-card">
        <div class="container-abstract" *ngIf="!success">
          <div class="flex-column p-lat">
            <span style="font-size: small; padding-bottom:.5em">{{orderType}} order N {{padWithLeadingZeros(detail.importOrderSequence)}}</span>
            <div class="flex-row p-bottom">
              <div class="container-icon">
                <span class="material-symbols-outlined" style="font-size:40px;opacity:.3;color:#8C2B87" *ngIf="dto.importOrderDetail.varietyUrlIcon.length<1">
                  no_photography
                </span>
                <img loading="lazy" [src]="getImageUrl(dto.importOrderDetail.varietyUrlIcon) | speciesImageUrl" style="border-radius: 7px; width: 100%; max-width: 65px; height: auto;" alt="" *ngIf="dto.importOrderDetail.varietyUrlIcon.length>0"/>
              </div>
              <div class="flex-column justify-center">
                <span style="text-transform: uppercase; font-size: medium; font-weight: bold; line-height:1.1em">{{detail | speciesName}}</span>
                <span style="text-transform: uppercase; font-size: medium; line-height:1.1em">{{detail.varietyName}}</span>
              </div>
            </div>
          </div>
          <div class="flex-column p-lat p-top">
            <span style="color: #8c2b87; font-size: small;"><strong>{{orderType}} order detail N</strong> {{padWithLeadingZeros(detail.sequence)}}</span>
            <span style="color: #8c2b87; font-size: small;"><strong>{{'UserPages.UserPurchaseOrders.AbstractOrder.ExporterLabel' | translate}}:</strong> <span class="pd-left">{{dto.importOrderDetail.exporterCompanyName ? dto.importOrderDetail.exporterCompanyName : "(No data)" }}</span></span>
            <span style="color: #8c2b87; font-size: small;"><strong>{{'UserPages.UserPurchaseOrders.AbstractOrder.ImporterLabel' | translate}}:</strong> <span class="pd-left">{{dto.importOrderDetail.importerCompanyName ? dto.importOrderDetail.importerCompanyName : "(No data)" }}</span></span>
          </div>
          <div class="flex-column p-lat p-top">
            <span style="color: #8c2b87; font-size: small;"><strong>{{'UserPages.UserPurchaseOrders.AbstractOrder.ContainerLabel' | translate}}:</strong> <span class="pd-left">{{dto.containerNumber ? dto.containerNumber : "(No data)" }}</span></span>
            <span style="color: #8c2b87; font-size: small;"><strong>{{'UserPages.UserPurchaseOrders.AbstractOrder.ETALabel' | translate}}:</strong> <span class="pd-left">{{dto.eta ? (dto.eta | date: 'dd-MM-yyyy') : "(No data)" }}</span></span>
            <span style="color: #8c2b87; font-size: small;"><strong>{{'UserPages.UserPurchaseOrders.AbstractOrder.ETDLabel' | translate}}:</strong> <span class="pd-left">{{dto.etd ? (dto.etd | date: 'dd-MM-yyyy') : "(No data)" }}</span></span>
          </div>
          <div class="flex-row p-lat">
            <span class="material-symbols-outlined" style="color: #8c2b87">pallet</span>
            <span style="margin-left: 10px;" *ngIf="!readFile">{{detail.palletQuantity}}</span>
            <span style="margin-left: 10px;" *ngIf="readFile">{{uniquePalletsRead}}</span>
          </div>
          <div class="flex-row p-lat">
            <app-location-info
            [type]="detail.transportType"
            [countryName]="detail.countryFromName"
            [countryCode]="detail.countryFromCode"
            [portName]="detail.portFromName"
            [airportName]="detail.fromAirport?.name"
            [cityName]="detail.fromCity?.name"
            [showLocationName]="true"
            ></app-location-info>
            <!-- <div class="flex justify-content-start align-items-center"  *ngIf="detail.transportType === 0">
              <img [flag]="detail.countryFromCode " height="40px" alt=""/>
              <div class="flex flex-column" style="margin-left: 10px;">
                <span style="font-weight: bolder; font-size: small;">{{detail.countryFromName}}</span>
                <span style="font-size: smaller;" *ngIf="detail.portFromName">{{detail.portFromName}}</span>
              </div>
            </div>

            <div class="flex justify-content-start align-items-center"  *ngIf="detail.transportType === 1">
              <img [flag]="detail.countryFromCode " height="40px" alt=""/>
              <div class="flex flex-column" style="margin-left: 10px;">
                <span style="font-weight: bolder; font-size: small;">{{detail.countryFromName}}</span>
                <span style="font-size: smaller;" *ngIf="detail.fromAirport">{{detail.fromAirport.name}}</span>
              </div>
            </div> -->
          </div>

          <!-- <div class="flex flex-column justify-content-center">
            <div class="flex justify-content-center">
              <span class="material-symbols-outlined" style="color: #6da043;"  *ngIf="detail.transportType === 0">directions_boat</span>
              <span class="material-symbols-outlined" style="color: #6da043;"  *ngIf="detail.transportType === 1">flight</span>
              <span class="material-symbols-outlined" style="color: #6da043;">arrow_forward_ios</span>
            </div>
            <div *ngIf="importOrderInfo?.delivery?.ship" class="flex justify-content-center">
              <span class="text-center" style="font-size: small;">{{ importOrderInfo?.delivery?.ship }}</span>
            </div>
          </div> -->
          <app-transport-type-icon [type]="detail.transportType"
          [ship]="importOrderInfo?.delivery?.ship">
        </app-transport-type-icon>

          <div class="flex-row p-lat">
            <app-location-info
            [type]="detail.transportType"
            [countryName]="detail.countryToName"
            [countryCode]="detail.countryToCode"
            [portName]="detail.portToName"
            [airportName]="detail.destinationAirport?.name"
            [cityName]="detail.destinationCity?.name"
            [showLocationName]="true"
            >

            </app-location-info>
            <!-- <div class="flex justify-content-start align-items-center" *ngIf="detail.transportType === 0">
              <img [flag]="detail.countryToCode " height="40px" alt=""/>
              <div class="flex flex-column" style="margin-left: 10px;">
                <span style="font-weight: bolder; font-size: small; ">{{detail.countryToName}}</span>
                <span style="font-size: smaller;">{{detail.portToName}}</span>
              </div>
            </div>

            <div class="flex justify-content-start align-items-center" *ngIf="detail.transportType === 1" >
              <img [flag]="detail.countryToCode " height="40px" alt=""/>
              <div class="flex flex-column" style="margin-left: 10px;">
                <span style="font-weight: bolder; font-size: small; ">{{detail.countryToName}}</span>
                <span style="font-size: smaller;">{{detail.destinationAirport?.name}}</span>
              </div>
            </div> -->

          </div>
        </div>

        <form [formGroup]="directSaleFormGroup">

        <div *ngIf="detail && (isCreate || isEdit) && !success" class="m-4 container-width">
          <div style="margin-top: 40px;">
            <p-table
              [value]="pallets"
              dataKey="dataKey"
              responsiveLayout="stack"
              [breakpoint]="'600px'"
              styleClass="p-datatable-gridlines"
              [scrollable]="true"
              [resizableColumns]="true"
              columnResizeMode="expand"
              scrollHeight="600px">
              <ng-template pTemplate="header">
                <tr>
                  <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.FolioHeader' | translate}}</th>
                  <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.SpeciesHeader' | translate}}</th>
                  <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.VarietyHeader' | translate}}</th>
                  <th *ngIf="exportOfferId && profile?.type === 1">{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.ProducerHeader' | translate}}</th>
                  <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.CspHeader' | translate}}</th>
                  <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.CsgHeader' | translate}}</th>
                  <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.SpeciesSizeHeader' | translate}}</th>
                  <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.CategoryHeader' | translate}}</th>
                  <th *ngIf="!isClosedSale">{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.HarvestDateHeader' | translate}}</th>
                  <th *ngIf="isClosedSale">{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PackingDateHeader' | translate}}</th>
                  <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.QualityControlDateHeader' | translate}}</th>
                  <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PackagingHeader' | translate}}</th>
                  <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletTypeHeader' | translate}}</th>
                  <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.TagHeader' | translate}}</th>
                  <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.BagTypeHeader' | translate}}</th>
                  <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.BoxTypeHeader' | translate}}</th>
                  <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.NetWeightHeader' | translate}}</th>
                  <!-- <th *ngIf="!isClosedSale">{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.ColdStorageHeader' | translate}}</th> -->
                  <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.BoxePerPalletHeader' | translate}}</th>
                  <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.MarksHeader' | translate}}</th>
                  <!-- <th *ngIf="!isClosedSale">ETD</th>
                  <th *ngIf="!isClosedSale">ETA</th> -->
                  <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.TemptaleHeader' | translate}}</th>
                  <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.OriginCountryHeader' | translate}}</th>
                  <!-- <th *ngIf="!isClosedSale" >{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.DestinationCountryHeader' | translate}}</th> -->
                  <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.GradeHeader' | translate}}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-pallet  let-editing="editing" let-ri="rowIndex">
                <tr>
                  <td [pEditableColumn]="pallet.palletNumber" pEditableColumnField="palletNumber">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="pallet.palletNumber" maxlength="20" required [readOnly]="true"/>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{pallet.palletNumber}}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td [pEditableColumn]="pallet.excelImportSpecies" pEditableColumnField="excelImportSpecies">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="pallet.excelImportSpecies" maxlength="100" required [readOnly]="true"/>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{pallet.excelImportSpecies}}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td [pEditableColumn]="pallet.excelImportVariety" pEditableColumnField="excelImportVariety">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [ngModelOptions]="{standalone: true}"  [(ngModel)]="pallet.excelImportVariety" maxlength="100" required [readOnly]="true"/>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{pallet.excelImportVariety}}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td [pEditableColumn]="pallet.producer" pEditableColumnField="producer" *ngIf="exportOfferId && profile?.type === 1">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="pallet.producer" maxlength="200" [readOnly]="true" required/>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{pallet.producer}}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td [pEditableColumn]="pallet.csp" pEditableColumnField="csp">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="pallet.csp" maxlength="200"/>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{pallet.csp}}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td [pEditableColumn]="pallet.csg" pEditableColumnField="csg">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="pallet.csg" maxlength="200"/>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{pallet.csg}}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td [pEditableColumn]="pallet.speciesSize" pEditableColumnField="speciesSize">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="pallet.speciesSize" maxlength="30"  [readOnly]="true"/>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{pallet.speciesSize}}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td [pEditableColumn]="pallet.excelImportLoadWeek" pEditableColumnField="category">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="pallet.excelImportLoadWeek" maxlength="50"  [readOnly]="true"/>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{pallet.category}}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td [pEditableColumn]="pallet.excelImportHarvestDate" pEditableColumnField="excelImportHarvestDate">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="pallet.excelImportHarvestDate" maxlength="50"/>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{pallet.excelImportHarvestDate}}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td [pEditableColumn]="pallet.excelImportQualityControlDate" pEditableColumnField="excelImportQualityControlDate">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="pallet.excelImportQualityControlDate" maxlength="50"/>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{pallet.excelImportQualityControlDate}}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td [pEditableColumn]="pallet.excelImportPackaging" pEditableColumnField="excelImportPackaging">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="pallet.excelImportPackaging" maxlength="50"/>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{pallet.excelImportPackaging}}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td [pEditableColumn]="pallet.excelImportPalletType" pEditableColumnField="excelImportPalletType">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="pallet.excelImportPalletType" maxlength="50"/>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{pallet.excelImportPalletType}}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td [pEditableColumn]="pallet.excelImportTag" pEditableColumnField="excelImportTag">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="pallet.excelImportTag" maxlength="50"/>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{pallet.excelImportTag}}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td [pEditableColumn]="pallet.excelImportBagType" pEditableColumnField="excelImportBagType">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="pallet.excelImportBagType" maxlength="50"/>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{pallet.excelImportBagType}}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td [pEditableColumn]="pallet.excelImportBoxSize" pEditableColumnField="excelImportBoxSize">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="pallet.excelImportBoxSize" maxlength="50"/>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{pallet.excelImportBoxSize}}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td [pEditableColumn]="pallet.excelImportNetWeight" pEditableColumnField="excelImportNetWeight">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="pallet.excelImportNetWeight" maxlength="50"  [readOnly]="true"/>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{pallet.excelImportNetWeight}}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <!-- <td [pEditableColumn]="pallet.excelImportFridgeStorage" pEditableColumnField="excelImportFridgeStorage" *ngIf="!isClosedSale">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="pallet.excelImportFridgeStorage" maxlength="50"/>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{pallet.excelImportFridgeStorage}}
                      </ng-template>
                    </p-cellEditor>
                  </td> -->
                  <td [pEditableColumn]="pallet.excelImportBoxesPerPallet" pEditableColumnField="excelImportBoxesPerPallet">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="pallet.excelImportBoxesPerPallet" maxlength="50" [readOnly]="true" />
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{pallet.excelImportBoxesPerPallet}}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td [pEditableColumn]="pallet.excelImportMark" pEditableColumnField="excelImportMark">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="pallet.excelImportMark" maxlength="50"/>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{pallet.excelImportMark}}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <!-- <td [pEditableColumn]="pallet.excelImportContainerNumber" pEditableColumnField="excelImportContainerNumber">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="pallet.excelImportContainerNumber" maxlength="50"/>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{pallet.excelImportContainerNumber}}
                      </ng-template>
                    </p-cellEditor>
                  </td> -->
                  <!-- <td *ngIf="!isClosedSale">{{ dto.etd ? (dto.etd | date:'dd-MM-yyyy') : '(Pending)' }}</td>
                  <td *ngIf="!isClosedSale">{{ dto.eta ? (dto.eta | date:'dd-MM-yyyy') : '(Pending)'}}</td> -->
                  <!-- <td>{{ dto.week ? dto.week : '(Pending)'}}</td> -->
                  <td pEditableColumn>
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="pallet.excelImportTemptale" maxlength="50"/>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{pallet.excelImportTemptale}}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td [pEditableColumn]="pallet.excelImportOriginCountry" pEditableColumnField="excelImportOriginCountry">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="pallet.excelImportOriginCountry" maxlength="50"/>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{pallet.excelImportOriginCountry}}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <!-- <td *ngIf="!isClosedSale">{{ dto.destinationPortName ? dto.destinationPortName : '(Pending)'}}</td> -->
                  <td [pEditableColumn]="pallet.excelImportGrade" pEditableColumnField="excelImportGrade">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="pallet.excelImportGrade" maxlength="50"/>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{pallet.excelImportGrade}}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <!-- <td [pEditableColumn]="pallet.excelImportCertificate1" pEditableColumnField="excelImportCertificate1">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="pallet.excelImportCertificate1" maxlength="50"/>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{pallet.excelImportCertificate1}}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td [pEditableColumn]="pallet.excelImportCertificate2" pEditableColumnField="excelImportCertificate1">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="pallet.excelImportCertificate2" maxlength="50"/>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{pallet.excelImportCertificate2}}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td [pEditableColumn]="pallet.excelImportCertificate3" pEditableColumnField="excelImportCertificate3">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="pallet.excelImportCertificate3" maxlength="50"/>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{pallet.excelImportCertificate3}}
                      </ng-template>
                    </p-cellEditor>
                  </td> -->
                  <!-- <td [pEditableColumn]="pallet.excelImportLoadWeek" pEditableColumnField="excelImportLoadWeek">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="pallet.excelImportLoadWeek" maxlength="50"/>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{pallet.excelImportLoadWeek}}
                      </ng-template>
                    </p-cellEditor>
                  </td> -->
                </tr>
              </ng-template>
            </p-table>
          </div>

          <div *ngIf="detail.isClosedSale">

            <div style="margin-top: 40px;" class="flex justify-content-end">
              <p-button
              (onClick)="showPalletPriceModal()"
              class="m-4"
              label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PricePalletButton' | translate}}"
              icon="pi pi-dollar"
              >
              </p-button>
              <p-button
              *ngIf="currentPrices.length > 0"
              class="m-4"
              (onClick)="showCurrentPalletPriceModal()"
              label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.ViewPricePalletButton' | translate}}"
              severity="secondary"
              icon="pi pi-eye"

              >
              </p-button>
            </div>

            <div class="flex flex-column mb-5">
              <span class="title-form">{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.TitleForm' | translate}}</span>
              <span>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.SubtitleForm' | translate}}</span>
            </div>

            <div class="flex border-top-1 border-300 align-items-stretch flex-wrap">
              <div class="w-3">
                <div class="surface-200 flex flex-column px-3 pt-3 pb-4 border-round-xs">
                  <ng-container *ngFor="let section of additionalInfoSections">

                    <div (click)="onSelectInfoSection(section)" onKeyPress=""
                      class="flex cursor-pointer align-content-center align-items-center"
                      [ngClass]="{
                        'selected-section': section.isSelected,
                        'non-selected-section': !section.isSelected
                      }">

                      <span class="material-symbols-outlined mr-2 icon">
                        {{ section.icon }}
                      </span>
                      <span class="label">
                        {{ section.label }}
                      </span>

                      <span *ngIf="section.isValid === false" class="material-symbols-outlined text-red-600 ml-2">
                        error
                      </span>
                      <span *ngIf="section.isValid" class="material-symbols-outlined text-green-400 ml-2">
                        check
                      </span>
                    </div>

                  </ng-container>
                </div>
              </div>

              <div class="w-9 align-items-stretch flex-wrap flex-column justify-content-between">
                <div class="flex flex-row">
                  <div *ngIf="selectedInfoSection === 'cold-storage'" class="w-full px-3 pt-4">
                    <div class="p-fluid formgrid mx-2 grid w-full">
                      <div class="field col-12 md:col-5">
                        <label for="fridgeStorage" style="font-weight: bolder;">
                          {{'UserPages.UserExportOffers.NewExportOffer.FridstorageFieldLabel' | translate}} *
                        </label>
                        <p-dropdown id="fridgeStorage"
                          formControlName="fridgeStorageId"
                          [options]="fridgeStorageOptions"
                          optionValue="id"
                          optionLabel="label"
                          [filter]="true"
                          filterBy="name"
                          [showClear]="true"
                          (onChange)="onChangeFridgestorage()"
                          placeholder="{{'UserPages.UserExportOffers.NewExportOffer.FridstorageFieldPlaceholder' | translate}}"
                          emptyMessage="{{'UserPages.UserExportOffers.NewExportOffer.FridgestorageEmptyMessage' | translate}}"
                          class="w-full">
                        </p-dropdown>
                        <small *ngIf="directSaleFormGroup.controls['fridgeStorageId'].invalid" class="p-error">
                          {{ getDirectSaleErrorMessage(directSaleFormGroup, 'fridgeStorageId') }}
                        </small>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="selectedInfoSection === 'instructive'" class="px-3 pt-4">
                    <div class="p-fluid formgrid mx-2 grid">
                      <div class="field col-12 md:col-4 mb-4 align-content-start">
                        <label for="harvestDate" style="font-weight: bolder;">
                          {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PackingDate' | translate}} *
                        </label>
                        <p-calendar
                          inputId="harvestDate"
                          formControlName="harvestDate"
                          appendTo="body"
                          [showButtonBar]="true"
                          [showIcon]="true"
                          placeholder="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PackingDatePlaceholder' | translate}}"
                          [showWeek]="true"
                          [firstDayOfWeek]="1"
                        ></p-calendar>
                        <small *ngIf="directSaleFormGroup.controls['harvestDate'].invalid" class="p-error">
                          {{'harvestDate' | formErrorMessage: directSaleFormGroup}}
                        </small>
                      </div>
                      <!-- <div class="field col-12 md:col-4 mb-4 align-content-start">
                        <label for="shelfLife" style="font-weight: bolder;">Shelf Life</label>
                        <p-inputNumber inputId="shelfLife" formControlName="shelfLife"  [min]="1" [max]="1000" placeholder="Shelf life"></p-inputNumber>

                        <small *ngIf="directSaleFormGroup.controls['shelfLife'].invalid" class="p-error">
                          {{'shelfLife' | formErrorMessage: directSaleFormGroup}}
                        </small>
                      </div> -->
                      <div class="field col-12 md:col-4 mb-4 align-content-start">
                        <label for="readyToLoadDate" style="font-weight: bolder;">
                          {{'UserPages.UserExportOffers.NewExportOffer.ReadyToLoadDateTime' | translate}}
                        </label>
                        <p-calendar
                          inputId="readyToLoadDate"
                          formControlName="readyToLoadDate"
                          appendTo="body"
                          [showButtonBar]="true"
                          [showIcon]="true"
                          placeholder="{{'UserPages.UserExportOffers.NewExportOffer.ReadyToLoadDateFieldPlaceholder' | translate}}"
                          [showWeek]="true"
                          [firstDayOfWeek]="1"
                          [showTime]="true"
                          ></p-calendar>
                        <small *ngIf="directSaleFormGroup.controls['readyToLoadDate'].invalid" class="p-error">
                          {{'readyToLoadDate' | formErrorMessage: directSaleFormGroup}}
                        </small>
                      </div>
                      <div class="field col-12 md:col-4 mb-4 align-content-start">
                        <label for="consigneeId" style="font-weight: bolder">
                          {{ "DirectSaleFormPage.ConsigneeFieldLabel" | translate }} *
                        </label>
                        <p-dropdown
                          id="consigneeId"
                          formControlName="consigneeId"
                          [options]="consignees"
                          optionValue="id"
                          optionLabel="companyName"
                          [filter]="true"
                          filterBy="companyName"
                          [showClear]="false"
                          placeholder="{{'DirectSaleFormPage.ConsigneeFieldLabel' | translate}}"
                        >
                        </p-dropdown>
                        <small *ngIf="directSaleFormGroup.controls['consigneeId'].invalid" class="p-error">
                          {{'consigneeId' | formErrorMessage: directSaleFormGroup}}
                        </small>
                      </div>
                      <div class="field col-12 md:col-4 mb-4 align-content-start">
                        <label for="notifyId" style="font-weight: bolder">
                          {{ "DirectSaleFormPage.NotifyFieldLabel" | translate }} *
                        </label>
                        <p-dropdown
                          id="notifyId"
                          formControlName="notifyId"
                          [options]="notifies"
                          optionValue="id"
                          optionLabel="companyName"
                          [filter]="true"
                          filterBy="companyName"
                          [showClear]="false"
                          placeholder="{{'DirectSaleFormPage.NotifyFieldLabel' | translate}}"
                        >
                        </p-dropdown>
                        <small *ngIf="directSaleFormGroup.controls['notifyId'].invalid" class="p-error">
                          {{'notifyId' | formErrorMessage: directSaleFormGroup}}
                        </small>
                      </div>
                      <div class="field col-12 md:col-4 mb-4 align-content-start">
                        <label style="font-weight: bolder" for="importToCountryId">
                          {{ "DirectSaleFormPage.DestinationCountryFieldLabel" | translate }} *
                        </label>
                        <p-dropdown
                          id="destinationCountryId"
                          [options]="countries"
                          formControlName="destinationCountryId"
                          optionLabel="name"
                          optionValue="id"
                          (onChange)="onChangeImportToCountry()"
                          [filter]="true"
                          [filterBy]="profile?.lang == 'en' ? 'name' : 'nameEs'"
                          [showClear]="true"
                          placeholder="{{'DirectSaleFormPage.DestinationCountryFieldLabel' | translate}}"
                        >
                          <ng-template pTemplate="selectedItem">
                            <div
                              class="flex align-items-center gap-2"
                              *ngIf="selectedCountryTo"
                            >
                              <img
                                loading="lazy"
                                [flag]="selectedCountryTo.code"
                                style="width: 18px"
                                alt=""
                              />
                              <div>{{ selectedCountryTo | countryDescription }}</div>
                            </div>
                          </ng-template>
                          <ng-template let-country pTemplate="item">
                            <div class="flex align-items-center gap-2">
                              <img
                                loading="lazy"
                                [flag]="country"
                                style="width: 18px"
                                alt=""
                              />
                              <div>{{ country | countryDescription }}</div>
                            </div>
                          </ng-template>
                        </p-dropdown>
                        <small *ngIf="directSaleFormGroup.controls['destinationCountryId'].invalid" class="p-error">
                          {{'destinationCountryId' | formErrorMessage: directSaleFormGroup}}
                        </small>
                      </div>
                      <div class="field col-12 md:col-4 mb-4 align-content-start"  *ngIf="programType === 0">
                        <label style="font-weight: bolder" for="portToId">
                          {{ "DirectSaleFormPage.DestinationPortFieldLabel" | translate }} *
                        </label>
                        <p-dropdown
                          id="destinationPortId"
                          [options]="ports"
                          formControlName="destinationPortId"
                          optionLabel="name"
                          optionValue="id"
                          [filter]="true"
                          filterBy="name"
                          [showClear]="true"
                          placeholder="{{'DirectSaleFormPage.DestinationPortFieldLabel' | translate}}"
                        ></p-dropdown>
                        <small *ngIf="directSaleFormGroup.controls['destinationPortId'].invalid" class="p-error">
                          {{'destinationPortId' | formErrorMessage: directSaleFormGroup}}
                        </small>
                      </div>
                      <div class="field col-12 md:col-4 mb-4 align-content-start" *ngIf="programType === 1">
                        <label style="font-weight: bolder" for="airportId">
                          {{ "DirectSaleFormPage.AirportFieldLabel" | translate }} *
                        </label>
                        <p-dropdown
                          id="destinationAirportId"
                          [options]="airports"
                          formControlName="destinationAirportId"
                          optionLabel="name"
                          optionValue="id"
                          [filter]="true"
                          filterBy="name"
                          [showClear]="true"
                          placeholder="{{'DirectSaleFormPage.AirportFieldLabel' | translate}}"
                        ></p-dropdown>
                        <small *ngIf="directSaleFormGroup.controls['destinationAirportId'].invalid" class="p-error">
                          {{'destinationAirportId' | formErrorMessage: directSaleFormGroup}}
                        </small>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="selectedInfoSection === 'container'" class="px-3 pt-4">
                    <div class="p-fluid formgrid mx-2 grid">
                      <div class="field col-12 md:col-5 align-content-start" style="margin-bottom: 40px;">
                        <label for="containerCbm" style="font-weight: bolder;">{{'UserPages.UserExportOffers.NewExportOffer.CBMLabel' | translate}} *</label>
                        <p-inputNumber inputId="containerCbm" formControlName="containerCbm"
                          [min]="0"
                          [max]="100"
                          [useGrouping]="false"
                          [maxlength]="7"
                          [maxFractionDigits]="2"
                          locale="en-US"
                          mode="decimal"
                          [suffix]="'%'"
                          placeholder="%"
                        ></p-inputNumber>
                        <small *ngIf="directSaleFormGroup.controls['containerCbm'].invalid" class="p-error">
                          {{'containerCbm' | formErrorMessage: directSaleFormGroup}}
                        </small>
                      </div>
                      <div class="field col-12 md:col-5 align-content-start" style="margin-bottom: 40px;">
                        <label for="containerTemperature" style="font-weight: bolder;">
                          {{'UserPages.UserExportOffers.NewExportOffer.TemperatureLabel' | translate}} *
                        </label>
                        <p-inputNumber
                          inputId="containerTemperature"
                          formControlName="containerTemperature"
                          [useGrouping]="false"
                          [maxFractionDigits]="2"
                          locale="en-US"
                          [maxlength]="10"
                          [suffix]="'°C'"
                          placeholder="°C"
                          mode="decimal"
                        ></p-inputNumber>
                        <small *ngIf="directSaleFormGroup.controls['containerTemperature'].invalid" class="p-error">
                          {{'containerTemperature' | formErrorMessage: directSaleFormGroup}}
                        </small>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="selectedInfoSection === 'assignment'" class="px-3 pt-4 w-full">
                    <div class="p-fluid formgrid mx-2 grid">
                      <div class="field col-12 md:col-5 align-content-start">
                        <label for="forwarder" style="font-weight: bolder;">
                          {{'UserPages.UserExportOffers.NewExportOffer.ForwarderLabel' | translate}} *
                        </label>
                        <p-dropdown
                          inputId="forwarder"
                          formControlName="forwarder"
                          [options]="companyForwarders"
                          optionValue="id"
                          optionLabel="companyName"
                          placeholder="{{ 'ForwarderPage.ForwarderReviewsPending.Modal.SelectForwarderPlaceholder' | translate }}"
                          class="w-full"
                          appendTo="body">
                        </p-dropdown>
                        <small *ngIf="directSaleFormGroup.controls['forwarder'].invalid" class="p-error">
                          {{'forwarder' | formErrorMessage: directSaleFormGroup}}
                        </small>
                      </div>
                      <div class="field col-12 md:col-5 align-content-start">
                        <label for="customAgent" style="font-weight: bolder;">
                          {{'UserPages.UserExportOffers.NewExportOffer.CustomsAgentLabel' | translate}} *
                        </label>
                        <p-dropdown
                          inputId="customAgent"
                          formControlName="customAgent"
                          [options]="companyCustomAgents"
                          optionValue="id"
                          optionLabel="companyName"
                          placeholder="{{ 'CustomAgentPage.CustomAgentReviewsPending.Modal.SelectCustomAgentPlaceholder' | translate }}"
                          class="w-full"
                          appendTo="body">
                        </p-dropdown>
                        <small *ngIf="directSaleFormGroup.controls['customAgent'].invalid" class="p-error">
                          {{'customAgent' | formErrorMessage: directSaleFormGroup}}
                        </small>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="selectedInfoSection === 'observations'" class="px-3 pt-4 w-full">
                    <div class="p-fluid formgrid mx-2 grid">
                      <div class="w-full">
                        <label for="observations" style="font-weight: bolder;">
                          {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.AddObservation' | translate}}
                        </label>
                        <textarea
                          id="observations"
                          pInputTextarea
                          formControlName="observations"
                          class="mt-2 w-full"
                          placeholder="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.TypeHere' | translate}}"
                        >
                        </textarea>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="selectedInfoSection === 'qc-review' && !detail.isSelectOriginQCCompany" class="px-3 pt-4 w-full">
                    <div class="mx-2">
                      <p class="font-medium mb-4 mt-0">{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.SelectQCCompany' | translate}}</p>
                      <p-table
                        [value]="originQCCompanies"
                        selectionMode="single"
                        [(selection)]="selectedOriginQCCompany"
                        [paginator]="true"
                        [rows]="5"
                        responsiveLayout="scroll">
                        <ng-template pTemplate="header">
                          <tr class="text-center">
                            <th class="text-center">QC Company</th>
                            <th class="text-center">{{'ContainerOrderPage.QCCompanyModal.QCCompanyBasePricePerPalletHeader' | translate}}</th>
                            <th class="text-center">{{'ContainerOrderPage.QCCompanyModal.QCCompanyBasePricePerContainerHeader' | translate}}</th>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-company>
                          <tr [pSelectableRow]="company" class="text-center">
                            <td class="text-center">{{company.profile?.companyName}}</td>
                            <td class="text-center">{{company.basePricePerPallet | currency: 'USD':'US$'}}</td>
                            <td class="text-center">{{company.basePricePerContainer | currency: 'USD':'US$'}}</td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </div>
                  </div>
                </div>

                <div class="flex justify-content-end mr-4 grid p-fluid">
                  <p-button *ngIf="hasPreviousSection()" (onClick)="goToPreviousSection()"
                    label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.BackButton' | translate}}"
                    class="p-button-secondary col-2" styleClass="p-button-outlined" icon="pi pi-chevron-left"/>

                  <p-button *ngIf="hasNextSection()" (onClick)="goToNextSection()"
                    label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.ContinueButton' | translate}}"
                    class="p-button-primary ml-2 col-2" icon="pi pi-chevron-right" iconPos="right"/>

                  <p-button *ngIf="!hasNextSection()" (onClick)="save()" [loading]="loading"
                    label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.SaveButton' | translate}}"
                    class="p-button-primary ml-2 col-2"/>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="!detail.isClosedSale">
            <div class="grid" style="margin-top: 40px;">
              <div class="col-6"></div>
              <div class="col-6">
                <div class="grid p-fluid">
                  <div class="col-6">
                    <p-button (onClick)="onCancel()"
                      label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.BackButton' | translate}}"
                      styleClass="p-button-outlined" [loading]="loading"></p-button>
                  </div>
                  <div class="col-6">
                    <p-button (onClick)="save()"
                      label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.SaveButton' | translate}}"
                      [loading]="loading"></p-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
        </form>

        <div *ngIf="detail && !isCreate && !isEdit && !success" class="m-4 container-width">
          <p-table
            [value]="pallets"
            [tableStyle]="{ 'min-width': '50rem' }"
            [loading]="loading"
            responsiveLayout="stack"
            [breakpoint]="'600px'"
            styleClass="p-datatable-gridlines"
            [scrollable]="true"
            [resizableColumns]="true"
            columnResizeMode="expand"
            scrollHeight="600px">
            <ng-template pTemplate="header">
              <tr>
                <th>Status</th>
                <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.FolioHeader' | translate}}</th>
                <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.SpeciesHeader' | translate}}</th>
                <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.VarietyHeader' | translate}}</th>
                <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.ProducerHeader' | translate}}</th>
                <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.CspHeader' | translate}}</th>
                <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.CsgHeader' | translate}}</th>
                <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.SpeciesSizeHeader' | translate}}</th>
                <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.CategoryHeader' | translate}}</th>
                <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.HarvestDateHeader' | translate}}</th>
                <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.QualityControlDateHeader' | translate}}</th>
                <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PackagingHeader' | translate}}</th>
                <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletTypeHeader' | translate}}</th>
                <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.TagHeader' | translate}}</th>
                <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.BagTypeHeader' | translate}}</th>
                <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.BoxTypeHeader' | translate}}</th>
                <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.NetWeightHeader' | translate}}</th>
                <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.ColdStorageHeader' | translate}}</th>
                <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.BoxePerPalletHeader' | translate}}</th>
                <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.MarksHeader' | translate}}</th>
                <th>ETD</th>
                <th>ETA</th>
                <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.OriginCountryHeader' | translate}}</th>
                <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.DestinationCountryHeader' | translate}}</th>
                <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.TemptaleHeader' | translate}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-pallet>
              <tr>
                <td>
                  <i class="pi pi-hourglass" *ngIf="pallet.status == 1" pTooltip="Pending"></i>
                  <i class="pi pi-check" style="color: slateblue" *ngIf="pallet.status == 2" pTooltip="Approved"></i>
                  <i class="pi pi-times" style="color: darkred" *ngIf="pallet.status == 3" pTooltip="Rejected"></i>
                </td>
                <td class="flexbox">
                  <p>{{ pallet.palletNumber.slice(0, -4) }}</p>
                  <p [class.blur]="!hideBlur">{{ pallet.palletNumber.slice(-4) }}</p>
                </td>
                <td>{{pallet.excelImportSpecies}}</td>
                <td>{{pallet.excelImportVariety}}</td>
                <td>
                  <p  [class.blur]="!hideBlur">
                    {{pallet.producer}}
                  </p>
                </td>
                <td>
                  <p>
                    {{pallet.csp}}
                  </p>
                </td>
                <td>
                  <p>
                    {{pallet.csg}}
                  </p>
                </td>
                <td>{{pallet.speciesSize}}</td>
                <td>{{pallet.category}}</td>
                <td>{{pallet.excelImportHarvestDate}}</td>
                <td>{{pallet.excelImportQualityControlDate}}</td>
                <td>{{pallet.excelImportPackaging}}</td>
                <td>{{pallet.excelImportPalletType}}</td>
                <td>{{pallet.excelImportTag}}</td>
                <td>
                  <p  [class.blur]="!hideBlur">
                    {{!hideBlur ?  (pallet.excelImportBagType | mask) : pallet.excelImportBagType}}
                  </p>
                </td>
                <td>
                  <p  [class.blur]="!hideBlur">
                    {{!hideBlur ?  (pallet.excelImportBoxSize | mask) : pallet.excelImportBoxSize}}
                  </p>
                </td>
                <td>
                  <p  [class.blur]="!hideBlur">
                    {{!hideBlur ?  (pallet.excelImportNetWeight | mask) : pallet.excelImportNetWeight}}
                  </p>
                </td>
                <td>
                  <p  [class.blur]="!hideBlur">
                    {{!hideBlur ?  (pallet.excelImportFridgeStorage | mask) : pallet.excelImportFridgeStorage}}
                  </p>
                </td>
                <td>
                  <p  [class.blur]="!hideBlur">
                    {{!hideBlur ?  (pallet.excelImportBoxesPerPallet | mask) : pallet.excelImportBoxesPerPallet}}
                  </p>
                </td>
                <td>
                  <p  [class.blur]="!hideBlur">
                    {{!hideBlur ?  (pallet.excelImportMark | mask) : pallet.excelImportMark}}
                  </p>
                </td>
                <td>
                  <p  [class.blur]="!hideBlur">
                    {{ dto.etd ? (dto.etd | date:'dd-MM-yyyy') : '(Pending)'}}
                  </p>
                </td>
                <td>
                  <p  [class.blur]="!hideBlur">
                    {{ dto.eta ? (dto.eta | date:'dd-MM-yyyy') : '(Pending)'}}
                  </p>
                </td>
                <td>
                  <p  [class.blur]="!hideBlur">
                    {{!hideBlur ? (pallet.excelImportOriginCountry | mask) : pallet.excelImportOriginCountry  }}
                  </p>
                </td>
                <td>
                  <p  [class.blur]="!hideBlur">
                    {{ dto.destinationPortCountry ? !hideBlur ? (dto.destinationPortCountry | mask ) : dto.destinationPortCountry : '(Pending)'}}
                  </p>
                </td>
                <td>
                  <p  [class.blur]="!hideBlur">
                    {{!hideBlur ? (pallet.excelImportTemptale | mask) :  pallet.excelImportTemptale}}
                  </p>
                </td>
                <td>
                  <p  [class.blur]="!hideBlur">
                    {{!hideBlur ? (pallet.excelImportGrade | mask) :  pallet.excelImportGrade}}
                  </p>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>

        <div class="grid col-12" style="margin-top: 50px;" *ngIf="dto.importOrderDetail.isQCPaid ==  false && this.profile?.type == 2">
          <div class="col-6">
            <div *ngIf="itemQCSelected">
              <h3>Empresa QC</h3>
              <p>{{itemQCSelected?.profile?.CompanyName}}</p>
              <div>
                <p *ngIf="itemQCSelected?.isConsolidateContainer" >
                  {{'QCQuestions.HasConsolidatedContainer' | translate}}
                </p>
                <p *ngIf="!itemQCSelected?.isConsolidateContainer" >
                  {{'QCQuestions.NotHasConsolidatedContainer' | translate}}
                </p>
              </div>
              <div>
                <p *ngIf="itemQCSelected?.hasQCSystem" >
                  {{'QCQuestions.HasQcSystem' | translate}}
                </p>
                <p *ngIf="!itemQCSelected?.hasQCSystem" >
                  {{'QCQuestions.NotHasQcSystem' | translate}}
                </p>
                <p-table
                [value]="companySpeciesSelected"
                [paginator]="true"
                [rows]="5"
                >
                <ng-template pTemplate="header" >
                  <th>{{'QCDataTable.Name' | translate}}</th>
                  <th>{{'QCDataTable.Species' | translate}}</th>
                  <th>{{'QCDataTable.Standard' | translate}}</th>
                  <th>{{'QCDataTable.Tolerance' | translate}}</th>
                  <th>{{'QCDataTable.QCPrice' | translate}}</th>
                  <th>{{'QCDataTable.ContainerPrice' | translate}}</th>
                </ng-template>
                <ng-template pTemplate="body" let-companySpecie>
                  <tr>
                    <td style="text-align: center;">{{itemQCSelected?.profile?.companyName}}</td>
                    <td style="text-align: center;">{{companySpecie.species.name}}</td>
                    <td style="text-align: center;">{{companySpecie.standards}}</td>
                    <td style="text-align: center;">{{companySpecie.tolerance}}</td>
                    <td style="text-align: center;">{{companySpecie.qcCost  | currency: 'USD':'US$' }}</td>
                    <td style="text-align: center;">{{companySpecie.qcCostPerContainer | currency: 'USD':'US$'}}</td>
                  </tr>
                </ng-template>
                </p-table>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="col-12 flex justify-content-end">
              <p-button label="QC Company" (onClick)="showSelectQCCompany()" styleClass="p-button-outlined"></p-button>
              <p-button *ngIf="itemQCSelected.id != 0"
              label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.ConfirmQcPurchase' | translate}}"
              (click)="onAccept()" [style]="{'margin-left': '30px'}"></p-button>
            </div>
          </div>
        </div>

        <div *ngIf="success">
          <div class="flex align-items-center justify-content-center flex-column">
            <i class="pi pi-check-circle" style="font-size: 2.5rem"></i>
            <h1>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.SuccessMessageText' | translate}}</h1>
            <p-button label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.AcceptButton' | translate}}" (click)="onCancel()"></p-button>
          </div>
        </div>
      </div>

    </div>

  </p-tabPanel>

  <p-tabPanel header="{{'TabVerifyPallets.RevisionQCHeader' | translate}}">
    <div class="card" *ngIf="dto && detail">
      <div class="header-card">
        <div class="container-title">
          <h2 class="title-main">Origin QC Reviews</h2>
        </div>
      </div>
      <div class="body-card">
        <div class="container-abstract" *ngIf="!success">
          <div class="flex-column p-lat">
            <span style="font-size: small; padding-bottom:.5em">{{orderType}} order N {{padWithLeadingZeros(detail.importOrderSequence)}}</span>
            <div class="flex-row p-bottom">
              <div class="container-icon">
                <span class="material-symbols-outlined" style="font-size:40px;opacity:.3;color:#8C2B87" *ngIf="dto.importOrderDetail.varietyUrlIcon.length<1">
                  no_photography
                </span>
                <img loading="lazy"
                [src]="getImageUrl(dto.importOrderDetail.varietyUrlIcon) | speciesImageUrl" style="border-radius: 7px; width: 100%; max-width: 65px; height: auto;" alt="" *ngIf="dto.importOrderDetail.varietyUrlIcon.length>0"/>
              </div>
              <div class="flex-column justify-center">
                <span style="text-transform: uppercase; font-size: medium; font-weight: bold; line-height:1.1em">{{detail | speciesName}}</span>
                <span style="text-transform: uppercase; font-size: medium; line-height:1.1em">{{detail.varietyName}}</span>
              </div>
            </div>
          </div>
          <div class="flex-column p-lat p-top">
            <span style="color: #8c2b87; font-size: small;"><strong>{{orderType}} order detail N</strong> {{padWithLeadingZeros(detail.sequence)}}</span>
            <span style="color: #8c2b87; font-size: small;"><strong>{{'UserPages.UserPurchaseOrders.AbstractOrder.ExporterLabel' | translate}}:</strong> <span class="pd-left">{{dto.importOrderDetail.exporterCompanyName ? dto.importOrderDetail.exporterCompanyName : "(No data)" }}</span></span>
            <span style="color: #8c2b87; font-size: small;"><strong>{{'UserPages.UserPurchaseOrders.AbstractOrder.ImporterLabel' | translate}}:</strong> <span class="pd-left">{{dto.importOrderDetail.importerCompanyName ? dto.importOrderDetail.importerCompanyName : "(No data)" }}</span></span>
          </div>
          <div class="flex-column p-lat p-top">
            <span style="color: #8c2b87; font-size: small;"><strong>{{'UserPages.UserPurchaseOrders.AbstractOrder.ContainerLabel' | translate}}:</strong> <span class="pd-left">{{dto.containerNumber ? dto.containerNumber : "(No data)" }}</span></span>
            <span style="color: #8c2b87; font-size: small;"><strong>{{'UserPages.UserPurchaseOrders.AbstractOrder.ETALabel' | translate}}:</strong> <span class="pd-left">{{dto.eta ? dto.eta : "(No data)" }}</span></span>
            <span style="color: #8c2b87; font-size: small;"><strong>{{'UserPages.UserPurchaseOrders.AbstractOrder.ETDLabel' | translate}}:</strong> <span class="pd-left">{{dto.etd ? dto.etd : "(No data)" }}</span></span>
          </div>
          <div class="flex-row p-lat">
            <span class="material-symbols-outlined" style="color: #8c2b87">pallet</span>
            <span style="margin-left: 10px;" *ngIf="!readFile">{{detail.palletQuantity}}</span>
            <span style="margin-left: 10px;" *ngIf="readFile">{{uniquePalletsRead}}</span>
          </div>
          <div class="flex-row p-lat">
            <div class="flex justify-content-start align-items-center"  *ngIf="detail.transportType === 0">
              <img [flag]="detail.countryFromCode " height="40px" alt=""/>
              <div class="flex flex-column" style="margin-left: 10px;">
                <span style="font-weight: bolder; font-size: small;">{{detail.countryFromName}}</span>
                <!-- <span style="font-size: smaller;" *ngIf="!detail.portFromName">{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.OriginPortText' | translate }} (?)</span> -->
                <span style="font-size: smaller;" *ngIf="detail.portFromName">{{detail.portFromName}}</span>
              </div>
            </div>

            <div class="flex justify-content-start align-items-center"  *ngIf="detail.transportType === 1">
              <img [flag]="detail.countryFromCode " height="40px" alt=""/>
              <div class="flex flex-column" style="margin-left: 10px;">
                <span style="font-weight: bolder; font-size: small;">{{detail.countryFromName}}</span>
                <!-- <span style="font-size: smaller;" *ngIf="!detail.portFromName">{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.OriginPortText' | translate }} (?)</span> -->
                <span style="font-size: smaller;" *ngIf="detail.portFromName">{{detail.fromAirport?.name}}</span>
              </div>
            </div>
          </div>

          <div class="flex flex-column justify-content-center">
            <div class="flex justify-content-center">
              <span class="material-symbols-outlined" style="color: #6da043;"  *ngIf="detail.transportType === 0">directions_boat</span>
              <span class="material-symbols-outlined" style="color: #6da043;"  *ngIf="detail.transportType === 1">flight</span>
              <span class="material-symbols-outlined" style="color: #6da043;">arrow_forward_ios</span>
            </div>
            <div *ngIf="importOrderInfo?.delivery?.ship" class="flex justify-content-center">
              <span class="text-center" style="font-size: small;">{{ importOrderInfo?.delivery?.ship }}</span>
            </div>
          </div>

          <div class="flex-row p-lat">
            <div class="flex justify-content-start align-items-center" *ngIf="detail.transportType === 0">
              <img [flag]="detail.countryToCode " height="40px" alt=""/>
              <div class="flex flex-column" style="margin-left: 10px;">
                <span style="font-weight: bolder; font-size: small; ">{{detail.countryToName}}</span>
                <span style="font-size: smaller;">{{detail.portToName}}</span>
              </div>
            </div>

            <div class="flex justify-content-start align-items-center" *ngIf="detail.transportType === 1" >
              <img [flag]="detail.countryToCode " height="40px" alt=""/>
              <div class="flex flex-column" style="margin-left: 10px;">
                <span style="font-weight: bolder; font-size: small; ">{{detail.countryToName}}</span>
                <span style="font-size: smaller;">{{detail.destinationAirport?.name}}</span>
              </div>
            </div>

          </div>
        </div>
        <div class="col-12 flex justify-content-end">
          <p-button styleClass="p-button-sm"  icon="pi pi-upload" label="{{ 'OrderDetailTabComponent.LoadDocumentExporter' | translate }}" (onClick)="visibleOperationUploadDialog = true"></p-button>
        </div>
        <p-table
          [value]="originQCReviews"
          [paginator]="true"
          [rows]="5"
          responsiveLayout="scroll">
          <ng-template pTemplate="header">
            <tr>
              <th>Status</th>
              <th>QC Company</th>
              <th>QC Date</th>
              <th>Price</th>
              <th>Observations</th>
              <th>Review Document</th>
              <th>Consolidation Document</th>
              <th>Arrival Document</th>
              <th>Survey Report Document</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-review>
            <tr>
              <td>
                <p-tag severity="warning" value="Created" *ngIf="review.status === 0 && review.typeUpload === 0"></p-tag>
                <p-tag severity="warning" value="Pending" *ngIf="review.status === 1 && review.typeUpload === 0"></p-tag>
                <p-tag severity="success" value="Reviewed" *ngIf="review.status === 2 && review.typeUpload === 0"></p-tag>
                <p-tag severity="success" value="Exporter upload" *ngIf="review.typeUpload === 1"></p-tag>
                <p-tag severity="danger" value="Cancelled" *ngIf="review.status === 3 && review.typeUpload === 0"></p-tag>
              </td>
              <td>{{review.qualityControlCompanyName ? review.qualityControlCompanyName : "Exporter"}}</td>
              <td>{{review.qualityControlDate ? (review.qualityControlDate | date: 'dd-MM-yyyy') : 'Pending review'}}</td>
              <td *ngIf="review.typeUpload === 0">{{review.price ? (review.price | currency: 'USD':'US$') : 'Pending review'}}</td>
              <td *ngIf="review.typeUpload === 1">{{ 0 | currency: 'USD':'US$'}}</td>
              <td>{{review.observations ? review.observations : 'No observations'}}</td>
              <td><p-button [disabled]="!(review.status == 2 && (review.reviewPdfLength > 0)) && !(review.typeUpload == 1  && review.reviewGuid)" pTooltip="View file" icon="pi pi-file-pdf"
                (onClick)="viewOriginQCReviewDocument(review)"
                styleClass="p-button-outlined">
              </p-button>
            </td>
              <td><p-button [disabled]="!(review.status == 2 && (review.consolidationPdfLength > 0)) && !(review.typeUpload == 1  && review.consolidationGuid)" pTooltip="View file" icon="pi pi-file-pdf"
                (onClick)="viewOriginQCConsolidationDocument(review)" styleClass="p-button-outlined">
              </p-button>
            </td>
              <td><p-button [disabled]="!(review.status == 2 && (review.reviewArrivalPdfLength > 0)) && !(review.typeUpload == 1  && review.reviewArrivalGuid)" pTooltip="View file" icon="pi pi-file-pdf"
                (onClick)="viewOriginQCArrivalDocument(review)"
                styleClass="p-button-outlined">
              </p-button>
              </td>
              <td><p-button [disabled]="!(review.status == 2 && (review.surveyReportPdfLength > 0))  && !(review.typeUpload == 1  && review.surveyReportGuid)" pTooltip="View file" icon="pi pi-file-pdf"
                (onClick)="viewOriginQCSurveyDocument(review)" styleClass="p-button-outlined">
              </p-button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

  </p-tabPanel>

  <p-tabPanel header="{{'TabVerifyPallets.DocumentsHeader' | translate}}">
    <div class="card" *ngIf="dto && detail">
      <div *ngIf="exportOfferId && profile?.type === 1">
        <div class="header-card">
          <div class="container-title">
            <div>
              <h2 class="title-main">{{'UserPages.UserExportOffers.EditExportOffer.FullTitle' | translate}}</h2>
            </div>
          </div>
        </div>
        <div class="body-card">
          <div class="container-abstract" *ngIf="!success">
            <div class="flex-column p-lat">
              <span style="font-size: small; padding-bottom:.5em">{{orderType}} order N {{padWithLeadingZeros(detail.importOrderSequence)}}</span>
              <div class="flex-row p-bottom">
                <div class="container-icon">
                  <span class="material-symbols-outlined" style="font-size:40px;opacity:.3;color:#8C2B87" *ngIf="dto.importOrderDetail.varietyUrlIcon.length<1">
                    no_photography
                  </span>
                  <img [src]="getImageUrl(dto.importOrderDetail.varietyUrlIcon) | speciesImageUrl" style="border-radius: 7px; width: 100%; max-width: 65px; height: auto;" alt="" *ngIf="dto.importOrderDetail.varietyUrlIcon.length>0"/>
                </div>
                <div class="flex-column justify-center">
                  <span style="text-transform: uppercase; font-size: medium; font-weight: bold; line-height:1.1em">{{detail | speciesName}}</span>
                  <span style="text-transform: uppercase; font-size: medium; line-height:1.1em">{{detail.varietyName}}</span>
                </div>
              </div>
            </div>
            <div class="flex-column p-lat p-top">
              <span style="color: #8c2b87; font-size: small;"><strong>{{orderType}} order detail N</strong> {{padWithLeadingZeros(detail.sequence)}}</span>
              <span style="color: #8c2b87; font-size: small;"><strong>{{'UserPages.UserPurchaseOrders.AbstractOrder.ExporterLabel' | translate}}:</strong> <span class="pd-left">{{dto.importOrderDetail.exporterCompanyName ? dto.importOrderDetail.exporterCompanyName : "(No data)" }}</span></span>
              <span style="color: #8c2b87; font-size: small;"><strong>{{'UserPages.UserPurchaseOrders.AbstractOrder.ImporterLabel' | translate}}:</strong> <span class="pd-left">{{dto.importOrderDetail.importerCompanyName ? dto.importOrderDetail.importerCompanyName : "(No data)" }}</span></span>
            </div>
            <div class="flex-column p-lat p-top">
              <span style="color: #8c2b87; font-size: small;"><strong>{{'UserPages.UserPurchaseOrders.AbstractOrder.ContainerLabel' | translate}}:</strong> <span class="pd-left">{{dto.containerNumber ? dto.containerNumber : "(No data)" }}</span></span>
              <span style="color: #8c2b87; font-size: small;"><strong>{{'UserPages.UserPurchaseOrders.AbstractOrder.ETALabel' | translate}}:</strong> <span class="pd-left">{{dto.eta ? (dto.eta | date: 'dd-MM-yyyy') : "(No data)" }}</span></span>
              <span style="color: #8c2b87; font-size: small;"><strong>{{'UserPages.UserPurchaseOrders.AbstractOrder.ETDLabel' | translate}}:</strong> <span class="pd-left">{{dto.etd ? (dto.etd | date: 'dd-MM-yyyy') : "(No data)" }}</span></span>
            </div>
            <div class="flex-row p-lat">
              <span class="material-symbols-outlined" style="color: #8c2b87">pallet</span>
              <span style="margin-left: 10px;" *ngIf="!readFile">{{detail.palletQuantity}}</span>
              <span style="margin-left: 10px;" *ngIf="readFile">{{uniquePalletsRead}}</span>
            </div>
            <div class="flex-row p-lat">
              <div class="flex justify-content-start align-items-center"  *ngIf="detail.transportType === 0">
                <img [flag]="detail.countryFromCode " height="40px" alt=""/>
                <div class="flex flex-column" style="margin-left: 10px;">
                  <span style="font-weight: bolder; font-size: small;">{{detail.countryFromName}}</span>
                  <!-- <span style="font-size: smaller;" *ngIf="!detail.portFromName">{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.OriginPortText' | translate }} (?)</span> -->
                  <span style="font-size: smaller;" *ngIf="detail.portFromName">{{detail.portFromName}}</span>
                </div>
              </div>

              <div class="flex justify-content-start align-items-center"  *ngIf="detail.transportType === 1">
                <img [flag]="detail.countryFromCode " height="40px" alt=""/>
                <div class="flex flex-column" style="margin-left: 10px;">
                  <span style="font-weight: bolder; font-size: small;">{{detail.countryFromName}}</span>
                  <!-- <span style="font-size: smaller;" *ngIf="!detail.portFromName">{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.OriginPortText' | translate }} (?)</span> -->
                  <span style="font-size: smaller;" *ngIf="detail.portFromName">{{detail.fromAirport?.name}}</span>
                </div>
              </div>
            </div>

            <div class="flex flex-column justify-content-center">
              <div class="flex justify-content-center">
                <span class="material-symbols-outlined" style="color: #6da043;"  *ngIf="detail.transportType === 0">directions_boat</span>
                <span class="material-symbols-outlined" style="color: #6da043;"  *ngIf="detail.transportType === 1">flight</span>
                <span class="material-symbols-outlined" style="color: #6da043;">arrow_forward_ios</span>
              </div>
              <div *ngIf="importOrderInfo?.delivery?.ship" class="flex justify-content-center">
                <span class="text-center" style="font-size: small;">{{ importOrderInfo?.delivery?.ship }}</span>
              </div>
            </div>

            <div class="flex-row p-lat">
              <div class="flex justify-content-start align-items-center" *ngIf="detail.transportType === 0">
                <img [flag]="detail.countryToCode " height="40px" alt=""/>
                <div class="flex flex-column" style="margin-left: 10px;">
                  <span style="font-weight: bolder; font-size: small; ">{{detail.countryToName}}</span>
                  <span style="font-size: smaller;">{{detail.portToName}}</span>
                </div>
              </div>

              <div class="flex justify-content-start align-items-center" *ngIf="detail.transportType === 1" >
                <img [flag]="detail.countryToCode " height="40px" alt=""/>
                <div class="flex flex-column" style="margin-left: 10px;">
                  <span style="font-weight: bolder; font-size: small; ">{{detail.countryToName}}</span>
                  <span style="font-size: smaller;">{{detail.destinationAirport?.name}}</span>
                </div>
              </div>

            </div>
          </div>
          <div class="col-6" style="margin-bottom: 10px;" >
              <app-select-button-documents (changeSelect)="changeDiv($event)" [lang]="this.profile?.lang ?? 'en'" ></app-select-button-documents>
          </div>
          <div *ngIf="exportOfferId && importOrderInfo && importOrderInfo.importOrder  && profile?.type === 1 && showDiv == 'certificates'">
            <div>
              <div class="container-title">
                <div>
                  <h2 class="title-main">{{'UserPages.UserExportOffers.EditExportOffer.PageTitle6' | translate}}</h2>
                  <p style="margin:0">{{'UserPages.UserExportOffers.EditExportOffer.PageSubtitle5' | translate}}</p>
                </div>
              </div>
            </div>
            <div class="body-card">
              <app-export-offer-product-certificates-crud
              [exportOfferId]="exportOfferId"
              [orderId]="importOrderInfo.importOrder.guid"
              [mode]="'order'">
              </app-export-offer-product-certificates-crud>
            </div>
          </div>

          <div *ngIf="exportOfferId && importOrderInfo && importOrderInfo.importOrder && profile?.type === 1 && showDiv == 'technical_documentation'">
              <div>
                <div class="container-title">
                  <div>
                    <h2 class="title-main">{{'UserPages.UserExportOffers.NewExportOffer.PageTitle6' | translate}}</h2>
                    <p style="margin:0">{{'UserPages.UserExportOffers.NewExportOffer.PageSubtitle6' | translate}}</p>
                  </div>
                </div>
              </div>
              <div class="body-card">
                <app-export-offer-documents-crud
                [exportOfferId]="exportOfferId"
                [orderId]="importOrderInfo.importOrder.guid"
                [mode]="'order'"
                ></app-export-offer-documents-crud>
              </div>
            </div>
          </div>
      </div>
    </div>
  </p-tabPanel>

  <p-tabPanel header="{{'TabVerifyPallets.LoadDocumentsHeader' | translate}}">
    <div class="card">
      <div class="header-card">
        <div class="container-title">
          <div>
            <h2 class="title-main title-color-text">{{'UploadOrdersFilePage.Title' | translate}}</h2>
          </div>
        </div>
      </div>
        <div class="body-card" *ngIf="detail">
            <app-upload-order-files
            [importOrderId]="detail.importOrderId"
            [orderDetailNumber]="detail.sequence"
            [orderNumber]="detail.importOrderSequence"
            [directSaleProgramId]="programId"
            >
            </app-upload-order-files>
        </div>
    </div>
  </p-tabPanel>
</p-tabView>

<!-- dialog for QC Companies  -->
<p-dialog header="QC Company" [(visible)]="visibleQCCompany" [style]="{width: '40vw'}">
  <p>{{'ContainerOrderPage.QCCompanyModal.Text' | translate}}</p>
  <p-table [value]="qcCompanies"
    [selection]="itemQCSelected"
    selectionMode="single"
    (onRowSelect)="onQCCompanyTableRowSelect($event)"
    [paginator]="true"
    [rows]="5"
    responsiveLayout="scroll">
    <ng-template pTemplate="header">
      <tr>
        <th>{{'ContainerOrderPage.QCCompanyModal.QCCompanyNameHeader' | translate}}</th>
        <th>{{'ContainerOrderPage.QCCompanyModal.QCCompanyBasePricePerPalletHeader' | translate}}</th>
        <th>{{'ContainerOrderPage.QCCompanyModal.QCCompanyBasePricePerContainerHeader' | translate}}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-company>
      <tr [pSelectableRow]="company">
        <td>{{company.profile?.companyName}}</td>
        <td>{{company.basePricePerPallet | currency: 'USD':'US$'}}</td>
        <td>{{company.basePricePerContainer | currency: 'USD':'US$'}}</td>
      </tr>
    </ng-template>
  </p-table>
  <ng-template pTemplate="footer">
    <p-button label="Cerrar" (onClick)="visibleQCCompany = false" styleClass="p-button-text"></p-button>
  </ng-template>
</p-dialog>

<!-- dialog for NoQC  -->
<p-dialog [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleDisclaimerQCDialog" [style]="{ 'min-width': '500px', 'max-width': '900px'}">
  <div class="grid flex align-items-center" style="padding: 0 50px;">
    <div class="col-12 md:col-12 flex justify-content-center align-items-start flex-column" style="font-size: 1.2rem">
      <p style="color: #4C4C4C; font-weight: bolder; margin: 0 auto">
        <span>{{'ContainerOrderPage.QCCompanyModal.TitleDisclaimer' | translate}}</span>
      </p>

      <p style="text-align: center; font-weight: 400; margin: 40px 7px 0">
        {{'ContainerOrderPage.QCCompanyModal.SentenceDisclaimerOne' | translate}}
      </p>

      <p style="text-align: center; font-weight: bolder; margin: 12px 0">
        {{'ContainerOrderPage.QCCompanyModal.SentenceDisclaimerTwo' | translate}}
      </p>

      <div class="col-12 flex justify-content-center align-items-center">
        <img src="../../../../assets/img/disclaimer_icon_fruzty_.png" style="width: 100%; max-width: 100px;" alt="fruzty-logo"/>
      </div>

      <div class="col-12 flex justify-content-evenly align-items-center" style="margin: 20px auto">
        <button pButton (click)="withoutNOQC()" style="color: #6EA042; border-radius: 5px; background-color: #FFFFFF; width: auto; max-width: 180px; height: 40px; border: 1px solid #6EA042">
          {{'ContainerOrderPage.QCCompanyModal.ButtonWithoutQCDisclaimer' | translate}}
        </button>
        <button pButton (click)="withNOQC()" style="background-color: #6EA042; border-radius: 5px; color: #FFFFFF; width: auto; max-width: 180px; height: 40px;">
          {{'ContainerOrderPage.QCCompanyModal.ButtonWithQCDisclaimer' | translate}}
        </button>
      </div>
    </div>
  </div>
</p-dialog>

<!-- dialog for new prices  -->
<p-dialog header="Detalle de sus pallets" [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visiblePalletsPrice" [style]="{width: '70vw'}">
  <div class="flex justify-content-start align-items-center">
    <p style="text-align: center; margin-right: 10px;">
      {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.ConfigureProducer' | translate}}
    </p>
    <p-inputSwitch [(ngModel)]="withProducer" (ngModelChange)="calculateTablePrice()"/>
  </div>
  <p-table
  [value]="palletsPrice"
  [paginator]="true"
  [rows]="10"
  [loading]="loading"
  responsiveLayout="stack"
  [breakpoint]="'600px'"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50]"
  >
  <ng-template pTemplate="header">
    <tr>
      <th>
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.SpeciesHeader' | translate}}
      </th>
      <th>
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.VarietyHeader' | translate}}
      </th>
      <th *ngIf="withProducer">
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.ProducerHeader' | translate}}
      </th>
      <th>
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.CategoryHeader' | translate}}
      </th>
      <th>
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.SpeciesSizeHeader' | translate}}
      </th>
      <th>
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.NetKilosHeader' | translate}}
      </th>
      <th>
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.BoxQuantityHeader' | translate}}
      </th>
      <th>
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.PriceHeader' | translate}}
      </th>
    </tr>
  </ng-template>
  <ng-template  pTemplate="body" let-palletPrice>
    <tr>
      <td>
        {{palletPrice.species ?? "Empty"}}
      </td>
      <td>
        {{palletPrice.variety ?? "Empty"}}
      </td>
      <td *ngIf="withProducer">
        {{palletPrice.producer ?? "Empty"}}
      </td>
      <td>
        {{palletPrice.category ?? "Empty"}}
      </td>
      <td>
        {{palletPrice.speciesSize ?? "Empty"}}
      </td>
      <td>
        {{palletPrice.netKilos ?? "Empty"}}
      </td>
      <td>
        {{palletPrice.boxPerPallets}}
      </td>
      <td>
        <p-inputNumber
        [(ngModel)]="palletPrice.price"
        placeholder="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.PricePlaceholder' | translate}}"
        mode="currency" currency="USD" locale="en-US" [min]="0"
        class="p-inputtext-sm input-styling"></p-inputNumber>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="footer">
    <tr>
        <td *ngIf="withProducer" colspan="6" ></td>
        <td *ngIf="!withProducer" colspan="5" ></td>
        <td>Total: {{totalBoxesPallets |number: '1.0-9'}}</td>
        <td></td>
    </tr>
</ng-template>
  </p-table>
  <ng-template pTemplate="footer">
    <p-button label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.ConfirmButton' | translate}}" (click)="confirmPalletPrice()"></p-button>
  </ng-template>
</p-dialog>

<!-- dialog for view current price -->
<p-dialog header="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.CurrentPricesHeader' | translate}}"
  [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleCurrentPalletsPrice" [style]="{width: '70vw'}">
  <p-table
  [value]="currentPrices"
  [paginator]="true"
  [rows]="10"
  [loading]="loading"
  responsiveLayout="stack"
  [breakpoint]="'600px'"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50]"
  >
  <ng-template pTemplate="header">
    <tr>
      <th>
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.SpeciesHeader' | translate}}
      </th>
      <th>
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.VarietyHeader' | translate}}
      </th>
      <th *ngIf="withProducer">
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.ProducerHeader' | translate}}
      </th>
      <th>
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.CategoryHeader' | translate}}
      </th>
      <th>
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.SpeciesSizeHeader' | translate}}
      </th>
      <th>
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.NetKilosHeader' | translate}}
      </th>
      <th>
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.BoxQuantityHeader' | translate}}
      </th>
      <th>
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.PriceHeader' | translate}}
      </th>
    </tr>
  </ng-template>
  <ng-template  pTemplate="body" let-palletPrice>
    <tr>
      <td>
        {{palletPrice.species ?? "Empty"}}
      </td>
      <td>
        {{palletPrice.variety ?? "Empty"}}
      </td>
      <td *ngIf="withProducer">
        {{palletPrice.producer ?? "Empty"}}
      </td>
      <td>
        {{palletPrice.category ?? "Empty"}}
      </td>
      <td>
        {{palletPrice.speciesSize ?? "Empty"}}
      </td>
      <td>
        {{palletPrice.netKilos ?? "Empty"}}
      </td>
      <td>
        {{palletPrice.boxPerPallets ?? "Empty"}}
      </td>
      <td>
        {{palletPrice.price | currency: 'USD'}}
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="footer">
    <tr>
        <td *ngIf="withProducer" colspan="6" ></td>
        <td *ngIf="!withProducer" colspan="5" ></td>
        <td>Total: {{totalBoxesPalletsCurrent |number: '1.0-9'}}</td>
        <td></td>
    </tr>
</ng-template>
  </p-table>
</p-dialog>

<p-dialog header="" [(visible)]="visibleLoadInformation"
  [modal]="true" (onHide)="onCloseLoadInformationDialog()"
  [style]="{width: '80vw'}" class="dialog-header-p load-pallets-dialog">
  <div class="custom-tabview mt-1">
    <p-tabView [(activeIndex)]="tabActiveIndex" (onChange)="onChangeLoadPalletsTab($event)">
      <p-tabPanel header="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.Tab1Label' | translate}}">
        <span>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.DialogInformation' | translate}}</span>
        <form [formGroup]="palletFormGroup">
          <div class="p-fluid formgrid grid mt-4">
            <div class="col-12 lg:col-3 mb-4 align-content-start">
              <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.SheetFiedlLabel' | translate}}</label>
              <p-dropdown [options]="excelSheets" [(ngModel)]="selectedSheet" [ngModelOptions]="{standalone: true}" [disabled]="!excelFile"></p-dropdown>
            </div>
            <div class="col-12 lg:col-3 lg:col-offset-6 mb-4 align-content-start">
              <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.LoadFileFieldLabel' | translate}}</label>
              <p-fileUpload
                #excelUploader
                styleClass="w-full"
                mode="basic"
                [multiple]="false"
                [auto]="true"
                chooseLabel="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.LoadFileFieldPlaceholder' | translate}}"
                name="demo[]"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                [maxFileSize]="maxFileSize"
                (onSelect)="onSelectExcelFile(excelUploader)">
              </p-fileUpload>
              <span *ngIf="excelFile">{{excelFile.name}}</span>
            </div>
            <div class="field col-12 lg:col-3 mb-4 align-content-start">
              <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.StartRowFieldLabel' | translate}} *</label>
              <p-inputNumber formControlName="startRow" [disabled]="!excelFile" placeholder=""/>
              <small *ngIf="palletFormGroup.controls['startRow'].invalid" class="p-error">{{getErrorMessage(palletFormGroup, 'startRow')}}</small>
            </div>
            <div class="field col-12 lg:col-3 mb-4 align-content-start">
              <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.EndRowFieldLabel' | translate}} *</label>
              <p-inputNumber formControlName="endRow"  [disabled]="!excelFile" placeholder=""/>
              <small *ngIf="palletFormGroup.controls['endRow'].invalid" class="p-error">{{getErrorMessage(palletFormGroup, 'endRow')}}</small>
            </div>
            <div class="field col-12 lg:col-3 mb-4 align-content-start">
              <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.FolioColumnFieldLabel' | translate}} *</label>
              <input type="text" formControlName="folioColumn" pInputText maxlength="2" placeholder=""/>
              <small *ngIf="palletFormGroup.controls['folioColumn'].invalid" class="p-error">{{getErrorMessage(palletFormGroup, 'folioColumn')}}</small>
            </div>
            <div class="field col-12 lg:col-3 mb-4 align-content-start">
              <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.SpeciesColumnFieldLabel' | translate}} *</label>
              <input type="text" formControlName="speciesColumn" pInputText maxlength="2" placeholder=""/>
              <small *ngIf="palletFormGroup.controls['speciesColumn'].invalid" class="p-error">{{getErrorMessage(palletFormGroup, 'speciesColumn')}}</small>
            </div>
            <div class="field col-12 lg:col-3 mb-4 align-content-start">
              <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.VarietyColumnFieldLabel' | translate}} *</label>
              <input type="text" formControlName="varietyColumn" pInputText maxlength="2" placeholder=""/>
              <small *ngIf="palletFormGroup.controls['varietyColumn'].invalid" class="p-error">{{getErrorMessage(palletFormGroup, 'varietyColumn')}}</small>
            </div>
            <div class="field col-12 lg:col-3 mb-4 align-content-start">
              <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.ProducerColumnFieldLabel' | translate}} *</label>
              <input type="text" formControlName="producerColumn" pInputText maxlength="2" placeholder=""/>
              <small *ngIf="palletFormGroup.controls['producerColumn'].invalid" class="p-error">{{getErrorMessage(palletFormGroup, 'producerColumn')}}</small>
            </div>
            <!-- csg and csp fields  -->
            <div class="field col-12 lg:col-3 mb-4 align-content-start">
              <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.CspColumnFieldLabel' | translate}}</label>
              <input type="text" formControlName="cspColumn" pInputText maxlength="2" placeholder=""/>
            </div>
            <div class="field col-12 lg:col-3 mb-4 align-content-start">
              <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.CsgColumnFieldLabel' | translate}}</label>
              <input type="text" formControlName="csgColumn" pInputText maxlength="2" placeholder=""/>
            </div>
                  <!-- csg and csp fields  -->
            <div class="field col-12 lg:col-3 mb-4 align-content-start">
              <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.SpeciesSizeColumnFieldLabel' | translate}}</label>
              <input type="text" formControlName="speciesSizeColumn" pInputText maxlength="2" placeholder=""/>
            </div>
            <div class="field col-12 lg:col-3 mb-4 align-content-start">
              <label>Category</label>
              <input type="text" formControlName="categoryColumn" pInputText maxlength="2" placeholder=""/>
            </div>
            <div class="field col-12 lg:col-3 mb-4 align-content-start">
              <label *ngIf="!isClosedSale">{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.HarvestDateColumnFielLabel' | translate}}</label>
              <label *ngIf="isClosedSale">{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.PackingDateColumnFielLabel' | translate}}</label>
              <input type="text" formControlName="harvestDateColumn" pInputText maxlength="2" placeholder=""/>
            </div>
            <div class="field col-12 lg:col-3 mb-4 align-content-start">
              <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.QualityControlDateColumnFielLabel' | translate}}</label>
              <input type="text" formControlName="qualityControlDateColumn" pInputText maxlength="2" placeholder=""/>
            </div>
            <div class="field col-12 lg:col-3 mb-4 align-content-start">
              <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.PackagingColumnFielLabel' | translate}}</label>
              <input type="text" formControlName="packagingColumn" pInputText maxlength="2" placeholder=""/>
            </div>
            <div class="field col-12 lg:col-3 mb-4 align-content-start">
              <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.PalletTypeColumnFielLabel' | translate}}</label>
              <input type="text" formControlName="palletTypeColumn" pInputText maxlength="2" placeholder=""/>
            </div>
            <div class="field col-12 lg:col-3 mb-4 align-content-start">
              <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.TagColumnFielLabel' | translate}}</label>
              <input type="text" formControlName="tagColumn" pInputText maxlength="2" placeholder=""/>
            </div>
            <div class="field col-12 lg:col-3 mb-4 align-content-start">
              <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.BagTypeColumnFielLabel' | translate}}</label>
              <input type="text" formControlName="bagTypeColumn" pInputText maxlength="2" placeholder=""/>
            </div>
            <div class="field col-12 lg:col-3 mb-4 align-content-start">
              <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.BoxSizeColumnFielLabel' | translate}}</label>
              <input type="text" formControlName="boxSizeColumn" pInputText maxlength="2" placeholder=""/>
            </div>
            <div class="field col-12 lg:col-3 mb-4 align-content-start">
              <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.NetWeightColumnFielLabel' | translate}}</label>
              <input type="text" formControlName="netWeightColumn" pInputText maxlength="2" placeholder=""/>
            </div>
            <div class="field col-12 lg:col-3 mb-4 align-content-start">
              <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.BoxesPerPalletColumnFielLabel' | translate}}</label>
              <input type="text" formControlName="boxesPerPalletColumn" pInputText maxlength="2" placeholder=""/>
              <small *ngIf="palletFormGroup.controls['boxesPerPalletColumn'].invalid" class="p-error">{{getErrorMessage(palletFormGroup, 'boxesPerPalletColumn')}}</small>
            </div>
            <div class="field col-12 lg:col-3 mb-4 align-content-start">
              <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.MarkColumnFielLabel' | translate}}</label>
              <input type="text" formControlName="markColumn" pInputText maxlength="2" placeholder=""/>
            </div>
            <div class="field col-12 lg:col-3 mb-4 align-content-start">
              <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.TemptaleColumnFielLabel' | translate}}</label>
              <input type="text" formControlName="temptaleColumn" pInputText maxlength="2" placeholder=""/>
            </div>
            <div class="field col-12 lg:col-3 mb-4 align-content-start">
              <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.OriginCountryColumnFielLabel' | translate}}</label>
              <input type="text" formControlName="originCountryColumn" pInputText maxlength="2" placeholder=""/>
            </div>
            <div class="field col-12 lg:col-3 mb-4 align-content-start">
              <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.GradeColumnFielLabel' | translate}}</label>
              <input type="text" formControlName="gradeColumn" pInputText maxlength="2" placeholder=""/>
            </div>
          </div>
        </form>
      </p-tabPanel>
      <p-tabPanel header="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.Tab2Label' | translate}}">
        <div class="flex flex-column">
          <span class="text-lg font-bold mb-1">
            {{ getLoadPalletsStepTitle() }}
          </span>
          <span>
            {{ getLoadPalletsStepDetail() }}
          </span>
          <div class="mt-4">
            <app-copy-paste-excel
              (getPastedPallets)="getPastedPallets($event)"
            />
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>
  <ng-template pTemplate="footer">
    <div class="pb-3 flex flex-row justify-content-end">
      <div *ngIf="tabActiveIndex === 0" class="flex w-12 md:w-3">
        <div class="w-full">
          <p-button (click)="onLoadExcel2(true)" [disabled]="!excelFile" onKeyPress=""
            styleClass="w-full"
            label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.LoadButton' | translate}}">
          </p-button>
        </div>
      </div>
      <div *ngIf="tabActiveIndex === 1" class="flex w-full gap-3 justify-content-end">
        <div *ngIf="loadPalletsStep === 2" class="flex w-12 md:w-3">
          <div class="w-full">
            <p-button (onClick)="loadPalletsPreviousStep()"
              styleClass="p-button-outlined w-full"
              label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.BackButton' | translate}}">
            </p-button>
          </div>
        </div>
        <div *ngIf="loadPalletsStep === 1 || loadPalletsStep === 2" class="flex w-12 md:w-3">
          <div class="w-full">
            <p-button [disabled]="loadPalletsStep === 1" (onClick)="loadPalletsNextStep()"
              styleClass="w-full"
              label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadButton' | translate}}">
            </p-button>
          </div>
        </div>
        <div *ngIf="loadPalletsStep === 3" class="flex w-12 md:w-3">
          <div class="w-full">
            <p-button (onClick)="loadPalletsPreviousStep()"
              styleClass="p-button-outlined w-full"
              label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.BackButton' | translate}}">
            </p-button>
          </div>
        </div>
        <div *ngIf="loadPalletsStep === 3" class="flex w-12 md:w-3">
          <div class="w-full">
            <p-button (onClick)="loadPalletsNextStep()"
              styleClass="w-full"
              label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.ContinueButton' | translate}}">
            </p-button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</p-dialog>

<p-dialog header="{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.ModalTitle' | translate}}" [(visible)]="loadFridgestorageDialogVisible" [style]="{width: '70%'}" [modal]="true">
  <form [formGroup]="fridgestorageFormGroup">
    <div class="p-fluid formgrid grid" style="padding: 20px;">
      <div class="field col-12 xl:col-6 lg:col-6" style="margin-bottom: 40px;">
        <label for="fridgestorageName">{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.NameFieldLabel' | translate}} *</label>
        <input id="fridgestorageName" formControlName="fridgestorageName" type="text" pInputText [maxlength]="300" required autofocus placeholder="{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.NameFieldPlaceholder' | translate}}"/>
        <small *ngIf="submit && fridgestorageFormGroup.controls['fridgestorageName'].invalid" class="p-error">{{getErrorMessage(fridgestorageFormGroup, 'fridgestorageName')}}</small>
      </div>
      <div class="field col-12 xl:col-6 lg:col-6" style="margin-bottom: 40px;">
        <label for="fridgestorageVat">{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.VatFieldLabel' | translate}}</label>
        <input id="fridgestorageVat" pInputText formControlName="fridgestorageVat" [maxlength]="20" placeholder="{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.VatFieldPlaceholder' | translate}}"/>
      </div>
      <div class="field col-12 xl:col-6 lg:col-6" style="margin-bottom: 40px;">
        <label for="fridgestorageFDA">{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.FDAFieldLabel' | translate}}</label>
        <input id="fridgestorageFDA" pInputText formControlName="fridgestorageFDA" [maxlength]="20" placeholder="{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.FDAFieldPlaceholder' | translate}}"/>
      </div>
      <div class="field col-12 xl:col-6 lg:col-6" style="margin-bottom: 40px;">
        <label for="fridgestorageContactName">{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.ContactNameFieldLabel' | translate}} *</label>
        <input id="fridgestorageContactName" formControlName="fridgestorageContactName" type="text" [maxlength]="300" pInputText required placeholder="{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.ContactNameFieldPlaceholder' | translate}}"/>
        <small *ngIf="submit && fridgestorageFormGroup.controls['fridgestorageContactName'].invalid" class="p-error">{{getErrorMessage(fridgestorageFormGroup, 'fridgestorageContactName')}}</small>
      </div>
      <div class="field col-12 xl:col-6 lg:col-6" style="margin-bottom: 40px;">
        <label for="fridgestorageContactEmail">{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.ContactEmailFieldLabel' | translate}} *</label>
        <input id="fridgestorageContactEmail" formControlName="fridgestorageContactEmail" type="text" [maxlength]="100" pInputText required placeholder="{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.ContactEmailFieldPlaceholder' | translate}}"/>
        <small *ngIf="submit && fridgestorageFormGroup.controls['fridgestorageContactEmail'].invalid" class="p-error">{{getErrorMessage(fridgestorageFormGroup, 'fridgestorageContactEmail')}}</small>
      </div>
      <div class="field col-12 xl:col-6 lg:col-6" style="margin-bottom: 40px;">
        <label for="fridgestorageContactAddress">{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.FactoryAddressLabel' | translate}} *</label>
        <input id="fridgestorageContactAddress" formControlName="fridgestorageContactAddress" type="text" [maxlength]="300" pInputText required placeholder="{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.FactoryAddressPlaceholder' | translate}}"/>
        <small *ngIf="submit && fridgestorageFormGroup.controls['fridgestorageContactAddress'].invalid" class="p-error">{{getErrorMessage(fridgestorageFormGroup, 'fridgestorageContactAddress')}}</small>
      </div>
      <div class="field col-12 xl:col-6 lg:col-6" style="margin-bottom: 40px;">
        <label for="fridgestorageContactCity">{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.ContactCityFieldLabel' | translate}} *</label>
        <input id="fridgestorageContactCity" formControlName="fridgestorageContactCity" type="text" [maxlength]="100" pInputText required placeholder="{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.ContactCityFieldPlaceholder' | translate}}"/>
        <small *ngIf="submit && fridgestorageFormGroup.controls['fridgestorageContactCity'].invalid" class="p-error">{{getErrorMessage(fridgestorageFormGroup, 'fridgestorageContactCity')}}</small>
      </div>
      <div class="field col-12 xl:col-6 lg:col-6" style="margin-bottom: 40px;">
        <label for="fridgestorageContactCountryId">{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.CountryFieldLabel' | translate}} *</label>
        <p-dropdown
            id="fridgestorageContactCountryId"
            [options]="countries"
            formControlName="fridgestorageContactCountryId"
            optionLabel="name"
            optionValue="id"
            [filter]="true"
            filterBy="name"
            [showClear]="true"
            placeholder="{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.CountryFieldPlaceholder' | translate}}"
            appendTo="body">
        </p-dropdown>
        <small *ngIf="submit && fridgestorageFormGroup.controls['fridgestorageContactCountryId'].invalid" class="p-error">{{getErrorMessage(fridgestorageFormGroup, 'fridgestorageContactCountryId')}}</small>
      </div>
      <div class="field col-12 xl:col-6 lg:col-6" style="margin-bottom: 40px;">
        <label for="fridgestorageContactPhone">{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.FridgeStorageContactPhoneLabel' | translate}} *</label>
        <input id="fridgestorageContactPhone" formControlName="fridgestorageContactPhone" type="text" pInputText [maxlength]="50" placeholder="{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.FridgeStorageContactPhonePlaceholder' | translate}}"/>
        <small *ngIf="submit && fridgestorageFormGroup.controls['fridgestorageContactPhone'].invalid" class="p-error">{{getErrorMessage(fridgestorageFormGroup, 'fridgestorageContactPhone')}}</small>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <p-button label="{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.CloseButton' | translate}}" (onClick)="onCancelNewFridgestorage()" styleClass="p-button-outlined"></p-button>
    <p-button label="{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.SaveButton' | translate}}" (onClick)="saveFridgestorage()" [loading]="loading"></p-button>
  </ng-template>
</p-dialog>

<p-dialog header=" {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.CleanPalletModal.CleanPalletConfirmation' | translate}}" [(visible)]="verifyDeleteConfig">
  <div class="col-12 flex justify-content-center align-items-center">
    <img src="../../../../assets/img/disclaimer_icon_fruzty_.png" style="width: 100%; max-width: 100px;" alt="fruzty-logo"/>
  </div>
  <p>
    {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.CleanPalletModal.PalletDescription' | translate}}
  </p>

  <ng-template pTemplate="footer">
    <p-button label="{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.CloseButton' | translate}}"  styleClass="p-button-outlined" (click)="verifyDeleteConfig = false" [loading]="loading"></p-button>
    <p-button label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.CleanPalletModal.CleanButton' | translate}}" (click)="cleanPalletsConfig()" [loading]="loading"></p-button>
  </ng-template>

</p-dialog>

<p-dialog header="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadLatamTitle' | translate}}"
[(visible)]="visibleLatamLoad" [style]="{width: '70vw'}" [modal]="true">

 <div>
  <p>{{'latamPalletModal.YourLoadText' | translate}}.</p>
 </div>
  <div class="flex justify-content-end mt-2">
    <p-button
      styleClass="p-button-sm"
      label="{{'MoreInformation.AddNewLineButton' | translate}}"
      (click)="addNewLine()">
    </p-button>
  </div>
  <p-table [value]="latamPallet">
    <ng-template pTemplate="header">
      <tr >
        <th>
          {{'latamPalletModal.SpecieHeader' | translate}}
        </th>
        <th>
          {{'latamPalletModal.VarietyHeader' | translate}}
        </th>
        <th>
          {{'latamPalletModal.ProducerHeader' | translate}}
        </th>
        <th>
          {{'latamPalletModal.SpeciesSizeHeader' | translate}}
        </th>
        <th>
          {{'latamPalletModal.CategoryHeader' | translate}}
        </th>
        <th>
          {{'latamPalletModal.NetWeightHeader' | translate}}
        </th>
        <th>
          {{'latamPalletModal.BoxesHeader' | translate}}
        </th>
        <th>
          {{'latamPalletModal.PalletsHeader' | translate}}
        </th>
        <th>
          {{'latamPalletModal.MoreInfoHeader' | translate}}
        </th>
      </tr>
    </ng-template>
      <ng-template pTemplate="body" let-pallet let-editing="editing" let-ri="rowIndex">
        <tr>
          <td [pEditableColumn]="pallet.specieName" pEditableColumn="specieName">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                pInputText
                type="text"
                [ngModelOptions]="{standalone: true}"
                [(ngModel)]="pallet.specieName" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ pallet.specieName }}
            </ng-template>
            </p-cellEditor>
          </td>
          <td [pEditableColumn]="pallet.varietyName" pEditableColumn="varietyName">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                pInputText
                type="text"
                [ngModelOptions]="{standalone: true}"
                [(ngModel)]="pallet.varietyName" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ pallet.varietyName }}
            </ng-template>
            </p-cellEditor>
          </td>
          <td [pEditableColumn]="pallet.producer" pEditableColumn="producer">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                pInputText
                type="text"
                [ngModelOptions]="{standalone: true}"
                [(ngModel)]="pallet.producer" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ pallet.producer }}
            </ng-template>
            </p-cellEditor>
          </td>
          <td [pEditableColumn]="pallet.speciesSize" pEditableColumn="speciesSize">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                pInputText
                type="text"
                [ngModelOptions]="{standalone: true}"
                [(ngModel)]="pallet.speciesSize" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ pallet.speciesSize }}
            </ng-template>
            </p-cellEditor>
          </td>
          <td [pEditableColumn]="pallet.category" pEditableColumn="category">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                pInputText
                [ngModelOptions]="{standalone: true}"
                type="text"
                [(ngModel)]="pallet.category" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ pallet.category }}
            </ng-template>
            </p-cellEditor>
          </td>
          <td [pEditableColumn]="pallet.netWeight" pEditableColumn="netWeight">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                pInputText
                type="number"
                [(ngModel)]="pallet.netWeight" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ pallet.netWeight }}
            </ng-template>
            </p-cellEditor>
          </td>
          <td [pEditableColumn]="pallet.boxes" pEditableColumn="boxes">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                pInputText
                type="number"
                [ngModelOptions]="{standalone: true}"
                [(ngModel)]="pallet.boxes" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ pallet.boxes }}
            </ng-template>
            </p-cellEditor>
          </td>
          <td [pEditableColumn]="pallet.pallets" pEditableColumn="pallets">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                pInputText
                type="number"
                [ngModelOptions]="{standalone: true}"
                [(ngModel)]="pallet.pallets" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ pallet.pallets }}
            </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <div class="flex flex-row justify-content-start">
              <p-button styleClass="p-button-sm"
              class="mr-2"
              icon="pi pi-file-edit"
              [style]="{'background-color':'#8c2b87'}"
              (click)="showMoreInfo(pallet,ri )">
              </p-button>
              <p-button styleClass="p-button-sm" *ngIf="ri >= 1"
                icon="pi pi-trash"
              severity="danger"
              (click)="deleteLine(ri )">
              </p-button>
            </div>
          </td>
        </tr>
    </ng-template>
  </p-table>
  <ng-template pTemplate="footer">
    <p-button styleClass="p-button-sm" label="{{'MoreInformation.SaveMoreInfoButton' | translate}}" (click)="uploadLatamPallets()"></p-button>
    <!-- <p-button></p-button> -->
  </ng-template>

</p-dialog>

<p-dialog header="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.MoreInfoTitle' | translate}}" [(visible)]="visibleMoreInfo" [style]="{width: '50vw'}" [modal]="true">

  <form [formGroup]="latamPalletForm">
  <div class="p-fluid formgrid grid">
      <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 20px;">
        <label>{{'MoreInformation.CSPLabel' | translate}}</label>
        <input type="text" formControlName="csp" pInputText placeholder=""/>
      </div>
      <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 20px;">
        <label>{{'MoreInformation.CSGLabel' | translate}}</label>
        <input type="text" formControlName="csg" pInputText  placeholder=""/>
      </div>
      <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 20px;">
        <label *ngIf="!isClosedSale">{{'MoreInformation.HarvestDateLabel' | translate}}</label>
        <label *ngIf="isClosedSale">{{'MoreInformation.PackingDateLabel' | translate}}</label>
          <p-calendar
            inputId="harvestDate"
            formControlName="harvestDate"
            appendTo="body"
            [showButtonBar]="true"
            [showIcon]="true"
            [showWeek]="true"
            [firstDayOfWeek]="1"></p-calendar>
      </div>
      <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 20px;">
        <label>{{'MoreInformation.QualityControlDateFieldLabel' | translate}}</label>
          <p-calendar
            inputId="qualityControlDate"
            formControlName="qualityControlDate"
            appendTo="body"
            [showButtonBar]="true"
            [showIcon]="true"
            [showWeek]="true"
            [firstDayOfWeek]="1"></p-calendar>
      </div>
      <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 20px;">
        <label>{{'MoreInformation.PackagingFieldLabel' | translate}}</label>
        <input type="text" formControlName="packaging" pInputText  placeholder=""/>
      </div>
      <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 20px;">
        <label>{{'MoreInformation.PalletTypeLabel' | translate}}</label>
        <input type="text" formControlName="palletType" pInputText  placeholder=""/>
      </div>
      <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 20px;">
        <label>{{'MoreInformation.TagLabel' | translate}}</label>
        <input type="text" formControlName="bagType" pInputText  placeholder=""/>
      </div>
      <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 20px;">
        <label>{{'MoreInformation.BagType' | translate}}</label>
        <input type="text" formControlName="boxSize" pInputText  placeholder=""/>
      </div>
      <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 20px;">
        <label>{{'MoreInformation.BoxSizeLabel' | translate}}</label>
        <input type="text" formControlName="mark" pInputText  placeholder=""/>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <p-button label="{{'MoreInformation.SaveMoreInfoButton' | translate}}" (click)="saveLatamInfo()"></p-button>
  </ng-template>

</p-dialog>

  <p-dialog header="{{'UploadDocumentDialog.Title' | translate}}" [(visible)]="visibleOperationUploadDialog" [style]="{width: '70%'}">
    <div class="grid">
        <div class="col-4">
            <input pInputText id="name" type="text"
            placeholder="{{'UploadDocumentDialog.NameDocumentPlaceholder' | translate}}" [(ngModel)]="name" style="width: 100%;"/>
        </div>
        <div class="col-4" >
            <p-dropdown [options]="operationDocumentTypes"
            [(ngModel)]="documentTypeViewId"
            placeholder="{{'UploadDocumentDialog.TypeDocumentPlaceholder' | translate}}"
            (onChange)="onSelectDocumentType($event)" styleClass="mb-2"
            optionLabel="name" optionValue="id"></p-dropdown>
          </div>
        <div class="col-12">
            <p-fileUpload
            #fileUploader
            [showUploadButton]="false"
            [multiple]="false"
            accept=".pdf"
            name="pdf"
            [maxFileSize]="5000000"
            chooseLabel="{{'UploadDocumentDialog.DocumentPlaceholder' | translate}}"
            (onSelect)="onSelect($event)"/>
        </div>
    </div>
    <ng-template pTemplate="footer">
      <p-button label="{{'UploadDocumentDialog.BackButton' | translate}}" (onClick)="visibleOperationUploadDialog = false" [loading]="loading" styleClass="p-button-outlined"></p-button>
      <p-button label="{{'UploadDocumentDialog.UploadButton' | translate}}" (onClick)="upload()" [loading]="loading"></p-button>
  </ng-template>
  </p-dialog>

  <!-- <p-dialog header="{{'AssignStock.AssignPalletTitle' | translate}}" [(visible)]="visibleStockDialog"  [style]="{width: '70%'}">

    <div *ngIf="detail">
      <app-assign-stock #assignStockComponent [orderDetailGuid]="detail.id" [isOrderLoad]="true"
      (onCancelAssignStock)="cancelOrder()" (onAssignStock)="assignOrder()" >
    </app-assign-stock>
    </div>
      <ng-template pTemplate="footer">
      <div class="flex justify-content-end gap-2">
        <p-button label="{{'AssignStock.CancelLabel' | translate}}" styleClass="p-button-outlined" (click)="cancelOrder()" [loading]="loading"></p-button>
        <p-button label="{{'AssignStock.AssignLabel' | translate}}" (click)="invokeAssignPalletStock()" [loading]="loading"  ></p-button>
      </div>
  </ng-template>
  </p-dialog> -->


